<template>
  <v-dialog v-model="showing_payment_modal" persistent eager max-width="650">
    <v-card>
      <v-form
        ref="form"
        v-model="payment_form_status"
        v-on:submit.prevent="add_form_validate"
      >
        <v-card-title class="headline">
          {{ $t("config_payment.config_payment") }} (
          {{
            form_mode === FORM_MODES.ADD
              ? $t("config_academic.addnew")
              : $t("config_academic.edit")
          }}
          )
        </v-card-title>

        <hr />

        <v-card-text class="mt-5">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <v-text-field
                v-bind:label="$t('config_academic.year')"
                v-model="configPayment_year"
                type="number"
                outlined
                dense
                v-bind:rules="configPaymentRules"
            /></v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <v-autocomplete
                v-model="configPayment_semester"
                v-bind:label="$t('config_academic.semester')"
                v-bind:items="semesters"
                v-bind:item-value="(item) => item.semester"
                v-bind:item-text="(item) => item.semester"
                v-bind:rules="requiredRules"
                outlined
                dense
              ></v-autocomplete
            ></v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="mt-5">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configPayment_startDatetimeNoCharge"
                v-bind:label="$t('config_payment.start_datetime_no_charge')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configPayment_endDatetimeNoCharge"
                v-bind:label="$t('config_payment.end_datetime_no_charge')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configPayment_startDatetimeRegistCharge"
                v-bind:label="$t('config_payment.start_datetime_regist_charge')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configPayment_endDatetimeRegistCharge"
                v-bind:label="$t('config_payment.end_datetime_regist_charge')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <v-text-field
                v-model="configPayment_registCharge"
                v-bind:label="$t('config_payment.regist_charge')"
                prepend-icon="mdi-currency-thb"
                type="number"
                v-bind:rules="requiredRules"
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <v-text-field
                v-model="configPayment_payLateChargePerDay"
                v-bind:label="$t('config_payment.pay_late_charge_per_day')"
                prepend-icon="mdi-currency-thb"
                type="number"
                v-bind:rules="requiredRules"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configPayment_startDatetimePayLateCharge"
                v-bind:label="
                  $t('config_payment.start_datetime_pay_late_charge')
                "
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configPayment_endDatetimePayLateCharge"
                v-bind:label="$t('config_payment.end_datetime_pay_late_charge')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configPayment_lastDatetimePayDate"
                v-bind:label="$t('config_payment.last_datetime_pay_date')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pb-5 pr-4">
          <v-spacer></v-spacer>
          <v-btn color="success" dark @click="form_validate()">
            {{ $t("config_academic.save") }}
          </v-btn>
          <v-btn color="error" dark @click="showing_payment_modal = false">{{
            $t("config_academic.cancel")
          }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import { objectTranslator } from "@/helper/translator";
import DateSelectCard from "@/components/info_cards/DateSelect";

// import { objectTranslator } from "@/helper/translator";
import { getYearsModified } from "@/helper/dateTime";
import validator from "@/helper/validator";
import ConfigProvider from "@/services/config.provider";

const configService = new ConfigProvider();
const { mapFields: mapOfficerConfigFields } = createHelpers({
  getterType: "officerConfig/getField",
  mutationType: "officerConfig/updateField",
});

const FORM_MODES = { ADD: 0, EDIT: 1 };

export default {
  name: "ConfigPayment",
  props: {
    toggle_loading: Function,
  },
  data: () => {
    return {
      FORM_MODES,
      semesters: ["1", "2", "3"],
      levels: [
        {
          LEVEL_ID: "1",
          LEVEL_NAME_EN: "ปริญญาตรี",
          LEVEL_NAME_TH: "ปริญญาตรี",
        },
        {
          LEVEL_ID: "2",
          LEVEL_NAME_EN: "บัณฑิตศึกษา (4+1, โท, เอก)",
          LEVEL_NAME_TH: "บัณฑิตศึกษา (4+1, โท, เอก)",
        },
      ],
      form_mode: null,
      payment_form_status: null,
      showing_payment_modal: false,

      configPayment_id: null,
      configPayment_year: null,
      configPayment_semester: null,
      configPayment_levelId: null,
      configPayment_startDatetimeNoCharge: null,
      configPayment_endDatetimeNoCharge: null,
      configPayment_startDatetimeRegistCharge: null,
      configPayment_endDatetimeRegistCharge: null,
      configPayment_registCharge: null,
      configPayment_startDatetimePayLateCharge: null,
      configPayment_endDatetimePayLateCharge: null,
      configPayment_payLateChargePerDay: null,
      configPayment_lastDatetimePayDate: null,

      configPaymentRules: [validator.required, validator.thaiYear],
      requiredRules: [validator.required],
    };
  },
  components: {
    DateSelectCard,
  },
  computed: {
    ...mapOfficerConfigFields({
      config_payments: "config_payments",
    }),
  },
  methods: {
    objectTranslator,
    getYearsModified,

    open_add_modal: function(level_id) {
      this.form_mode = FORM_MODES.ADD;
      this.$refs.form.reset();
      this.configPayment_levelId = level_id;
      this.showing_payment_modal = true;
    },
    open_edit_modal: function(item) {
      this.form_mode = FORM_MODES.EDIT;
      this.configPayment_id = item.ID;
      this.configPayment_year = item.YEAR;
      this.configPayment_semester = item.SEMESTER;
      this.configPayment_levelId = item.LEVEL_ID;
      this.configPayment_startDatetimeNoCharge = item.START_DATETIME_NO_CHARGE;
      this.configPayment_endDatetimeNoCharge = item.END_DATETIME_NO_CHARGE;
      this.configPayment_startDatetimeRegistCharge =
        item.START_DATETIME_REGIST_CHARGE;
      this.configPayment_endDatetimeRegistCharge =
        item.END_DATETIME_REGIST_CHARGE;
      this.configPayment_registCharge = item.REGIST_CHARGE;
      this.configPayment_startDatetimePayLateCharge =
        item.START_DATETIME_PAY_LATE_CHARGE;
      this.configPayment_endDatetimePayLateCharge =
        item.END_DATETIME_PAY_LATE_CHARGE;
      this.configPayment_payLateChargePerDay = item.PAY_LATE_CHARGE_PER_DAY;
      this.configPayment_lastDatetimePayDate = item.LAST_DATETIME_PAY_DATE;
      this.showing_payment_modal = true;
    },
    form_validate: function() {
      if (this.form_mode === FORM_MODES.ADD) {
        this.add_form_validate();
      } else if (this.form_mode === FORM_MODES.EDIT) {
        this.edit_form_validate();
      }
    },
    add_form_validate: async function() {
      this.$refs.form.validate();
      if (this.payment_form_status) {
        this.showing_payment_modal = false;
        this.toggle_loading(true);

        let response = await configService
          .setPayments({
            level_id: this.configPayment_levelId,
            year: this.configPayment_year,
            semester: this.configPayment_semester,
            start_datetime_no_charge:
              this.configPayment_startDatetimeNoCharge + " 00:00:00",
            end_datetime_no_charge:
              this.configPayment_endDatetimeNoCharge + " 23:59:59",
            start_datetime_regist_charge:
              this.configPayment_startDatetimeRegistCharge + " 00:00:00",
            end_datetime_regist_charge:
              this.configPayment_endDatetimeRegistCharge + " 23:59:59",
            regist_charge: this.configPayment_registCharge,
            start_datetime_pay_late_charge:
              this.configPayment_startDatetimePayLateCharge + " 00:00:00",
            end_datetime_pay_late_charge:
              this.configPayment_endDatetimePayLateCharge + " 23:59:59",
            pay_late_charge_per_day: this.configPayment_payLateChargePerDay,
            last_datetime_pay_date:
              this.configPayment_lastDatetimePayDate + " 23:59:59",
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.toggle_loading(false);
          });
        this.$store.dispatch("officerConfig/getPayments");
        if (response && response.status)
          this.$toasted.success(this.$t("toasted.create_successfully"));
        else this.$toasted.error(this.$t("toasted.cannot_create"));

        this.toggle_loading(false);
      }
    },
    edit_form_validate: async function() {
      this.$refs.form.validate();
      if (this.payment_form_status) {
        this.showing_payment_modal = false;
        this.toggle_loading(true);

        let response = await configService
          .setPayments({
            // id: this.configPayment_id,
            level_id: this.configPayment_levelId,
            year: this.configPayment_year,
            semester: this.configPayment_semester,
            // check length in variable that have time or not. If it have time, length will have more than 10
            start_datetime_no_charge:
              this.configPayment_startDatetimeNoCharge.length === 10
                ? this.configPayment_startDatetimeNoCharge + " 00:00:00"
                : this.configPayment_startDatetimeNoCharge,
            end_datetime_no_charge:
              this.configPayment_endDatetimeNoCharge.length === 10
                ? this.configPayment_endDatetimeNoCharge + " 23:59:59"
                : this.configPayment_endDatetimeNoCharge,
            start_datetime_regist_charge:
              this.configPayment_startDatetimeRegistCharge.length === 10
                ? this.configPayment_startDatetimeRegistCharge + " 00:00:00"
                : this.configPayment_startDatetimeRegistCharge,
            end_datetime_regist_charge:
              this.configPayment_endDatetimeRegistCharge.length === 10
                ? this.configPayment_endDatetimeRegistCharge + " 23:59:59"
                : this.configPayment_endDatetimeRegistCharge,
            regist_charge: this.configPayment_registCharge,
            start_datetime_pay_late_charge:
              this.configPayment_startDatetimePayLateCharge.length === 10
                ? this.configPayment_startDatetimePayLateCharge + " 00:00:00"
                : this.configPayment_startDatetimePayLateCharge,
            end_datetime_pay_late_charge:
              this.configPayment_endDatetimePayLateCharge.length === 10
                ? this.configPayment_endDatetimePayLateCharge + " 23:59:59"
                : this.configPayment_endDatetimePayLateCharge,
            pay_late_charge_per_day: this.configPayment_payLateChargePerDay,
            last_datetime_pay_date:
              this.configPayment_lastDatetimePayDate.length === 10
                ? this.configPayment_lastDatetimePayDate + " 23:59:59"
                : this.configPayment_lastDatetimePayDate,
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.toggle_loading(false);
          });
        this.$store.dispatch("officerConfig/getPayments");
        if (response && response.status)
          this.$toasted.success(this.$t("toasted.edit_successfully"));
        else this.$toasted.error(this.$t("toasted.cannot_edit"));

        this.toggle_loading(false);
      }
    },
  },
  mounted: function() {},
};
</script>
